export enum FileTypes {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  DOCUMENT = 'DOCUMENT',
  AUDIO = 'AUDIO',
  OTHER = 'OTHER',
  IMAGE_OR_VIDEO = 'IMAGE_OR_VIDEO',
}
